<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Filters</span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="content pb-spacing-3xl">
  <app-filters-form
    [filterForm]="config.data.filterForm"
    [filterActionsPlacement]="config.data.filterActionsPlacement"
    [filters]="config.data.filters"
    [clearButtonText]="'Clear All'"
    [ApplyButtonText]="config.data.ApplyButtonText"
    (formSubmit)="submit()"
    (cancel)="close()"
    (clearFilters)="clearFilters()"></app-filters-form>
</div>
